import React from 'react';
import { generateQRText, validateQRData } from '../utils/qrGenerators';

const QRPreview = ({ qrType, qrData, showPreview = true }) => {
  const qrText = generateQRText(qrType, qrData);
  const validation = validateQRData(qrType, qrData);

  if (!showPreview || !qrText) {
    return null;
  }

  const getPreviewTitle = () => {
    switch (qrType) {
      case 'url': return '🌐 URL';
      case 'text': return '📝 Texto';
      case 'vcard': return '👤 vCard';
      case 'wifi': return '📶 WiFi';
      default: return '📄 Conteúdo';
    }
  };

  const formatPreviewText = () => {
    if (qrType === 'vcard') {
      return qrText.split('\n').map((line, index) => (
        <div key={index} style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
          {line}
        </div>
      ));
    }
    
    if (qrType === 'wifi') {
      return (
        <div style={{ fontFamily: 'monospace', fontSize: '0.9rem' }}>
          {qrText}
        </div>
      );
    }
    
    return qrText;
  };

  return (
    <div className="preview-section" style={{ marginTop: '1rem' }}>
      <h4>{getPreviewTitle()}</h4>
      
      <div 
        className={`validation-message ${validation.isValid ? 'success' : 'error'}`}
        style={{
          padding: '0.5rem',
          borderRadius: '4px',
          marginBottom: '0.5rem',
          fontSize: '0.9rem',
          backgroundColor: validation.isValid ? '#d4edda' : '#f8d7da',
          color: validation.isValid ? '#155724' : '#721c24',
          border: `1px solid ${validation.isValid ? '#c3e6cb' : '#f5c6cb'}`
        }}
      >
        <strong>{validation.isValid ? '✅' : '❌'}</strong> {validation.message}
      </div>

      {validation.isValid && (
        <div 
          className="preview-content"
          style={{
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            padding: '1rem',
            maxHeight: '200px',
            overflowY: 'auto',
            fontSize: '0.9rem',
            lineHeight: '1.4'
          }}
        >
          {formatPreviewText()}
        </div>
      )}
    </div>
  );
};

export default QRPreview;
